import React from 'react';
import MPCheckoutConfigForm from 'forms/MPCheckoutConfigForm';

export default (): JSX.Element => <MPCheckoutConfigForm />;
